import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { PAGE_NAME_STEPS, Need4SteelWizardService } from '../services/need4steel-wizard.service';

function getStepIndex(url: string) {
	const index = PAGE_NAME_STEPS.findIndex(pageNameStep => url.includes(pageNameStep));
	return index === -1 ? 0 : index;
}

export const need4SteelWizardEnterGuard: CanActivateFn = async (
	_: ActivatedRouteSnapshot,
	currentRoute: RouterStateSnapshot
) => {
	const router = inject(Router);
	const need4SteelWizardService = inject(Need4SteelWizardService);
	const stepIndex = getStepIndex(currentRoute.url);
	need4SteelWizardService.updateStepIndex(stepIndex);
	if (router.url === '/'
		&& currentRoute.url.includes('need4steel/wizard/summary')) {
		await router.navigateByUrl('need4steel/wizard', { replaceUrl: true });
		return true;
	}
	if (router.url.includes('need4steel/wizard/summary')
		|| need4SteelWizardService.isMillOfferIdPresent()) {
		return true;
	}
	const currentNavigation = router.getCurrentNavigation();
	if (currentNavigation?.extras.state) {
		const { millOfferId } = currentNavigation.extras.state;
		if (millOfferId) {
			return true;
		}
	}

	return false;
};
